import React, { ReactNode } from 'react';

const PageHeader = ({ title, children }: {title: string, children?: ReactNode}) => <section className="page-header"><h1>{title}</h1>{children}</section>;

export default PageHeader;
